import React from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import { categories, heCategories } from "../../fixtures/categories";
import sortBy from 'lodash/sortBy';

const CATEGORIES_LIST_LOCAL =
  navigator.language.includes('he') ? heCategories : categories;

const fileTypes = [
  { id: 'Specs', name: 'Specs'},
  { id: 'Plans', name: 'Plans & Changes'},
  { id: 'General', name: 'General Files'},
];

class CategoriesModal extends React.Component {
  state = {
    category: '55',
    fileType: 'Plans',
    location: '',
    disabled: false,
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  onConfirm = async () => {
    const { onConfirm, locations } = this.props;
    const { category, fileType, location } = this.state;

    let locationsObj = Object.values(locations.items)[0].unit;

    if (fileType === 'Specs') {
      locationsObj = Object.values(locations.items)[0].floor;
    }

    const categories = [category];
    this.setState({ disabled: true })
    await onConfirm({ categories, fileType, location: locationsObj[location] });

    this.setState({ disabled: false, category: '48', fileType: 'General', location: '' })
  };

  onCancel = async () => {
    const { onCancelUpload } = this.props;

    if (onCancelUpload) {
      onCancelUpload();
    }
  };

  render() {
    const { open, classes, locations } = this.props;
    const { category, fileType, location} = this.state;
    let { disabled } = this.state;

    // const categories = Object.values(CATEGORIES_LIST_LOCAL).filter(({forBlueprint}) => forBlueprint);
    const units = locations ? Object.values(Object.values(locations.items)[0].unit) : [];
    const floors = locations ? Object.values(Object.values(locations.items)[0].floor) : [];

    if (location === '') {
      disabled = true
    }

    const sortedUnits = sortBy( units, 'floorName' );

    return (
      <Dialog open={open || false} style={{marginTop: '-70px'}}>
        <div className="file-category-select">
          {units.length >= 1 && fileType !== "Specs" &&
            <React.Fragment>
              <h2 style={{ marginTop: 10 }}>Select unit</h2>
              <select
                name="location"
                className="select-text"
                value={location}
                onChange={this.handleChange}
              >
                <option key={"key"} value="" disabled>
                  none
                </option>
                {sortedUnits.map(unit => (
                  <option key={unit.id} value={unit.id}>
                    {unit.floorName ? unit.floorName : ''} {unit.name}
                  </option>
                ))}
              </select>
            </React.Fragment>
          }

          {floors.length > 1 && fileType === "Specs" &&
            <React.Fragment>
              <h2 style={{ marginTop: 10 }}>Select floor</h2>
              <select
                name="location"
                className="select-text"
                value={location}
                onChange={this.handleChange}
              >
                {/*<option key={"key"} value="" disabled>*/}
                {/*  none*/}
                {/*</option>*/}
                {floors.map(floor => (
                  <option key={floor.id} value={floor.id}>
                    {floor.name}
                  </option>
                ))}
              </select>
            </React.Fragment>
          }
          {/* <span className="select-highlight" /> */}
          {/* <span className="select-bar" /> */}
            {/*<label className="select-label">Category</label>*/}
        </div>
        <div className="wrap-save-category">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <FlatButton
                style={{ width: "75px", color: "#fff", marginTop: "15px", marginRight: "10px" }}
                labelStyle={{ color: "#fff" }}
                hoverColor={"#77c723"}
                backgroundColor={"#6da92e"}
                label="Cancel"
                onClick={this.onCancel}
            />
            <FlatButton
              disabled={disabled}
              style={{ width: "75px", color: "#fff", marginTop: "15px" }}
              labelStyle={{ color: "#fff" }}
              hoverColor={"#77c723"}
              backgroundColor={"#6da92e"}
              label="Save"
              onClick={this.onConfirm}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default CategoriesModal;
